/* tslint:disable */

/**
 */
export class UserInput {
    user_disable?: boolean;
    style_search?: string;
    key_input?: string;
}
